<template>
  <div class="notes" style="z-index: 999" :class="{ open: isOpen }">
    <div class="notes-toggle" :class="{ open: isOpen }" @click="toggleNotes">
      Notes
      <ArrowLeftWhiteIcon />
    </div>
    <div class="notes-sidebar">
      <div style="display: flex; flex-direction: column; row-gap: 16px">
        <div v-for="(item, index) in notes" :key="item.id">
          <simple-info-block
            :info="item"
            :index="index"
            @updateNote="updateNote"
            @closeSidebar="isOpen = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleInfoBlock from '@/components/elements/simple-info-block'
import { mapActions, mapState } from 'vuex'
import ArrowLeftWhiteIcon from '@/assets/icons/components/arrow-left-white.svg'

export default {
  name: 'notesSidebar',
  components: { SimpleInfoBlock, ArrowLeftWhiteIcon },
  data() {
    return {
      isOpen: false,
      noteText: ""
    };
  },
  computed: {
    ...mapState({
      visit: state => state.visits?.visit,
      result: state => state.results?.results,
    }),
    // ...mapState('results', {
    //   notesForPractitioner (state) {
    //     return state?.notes?.$values
    //   }
    // }),
    practitionerNotesText () {
      const values = this.result?.record?.resultNotes?.$values
      if (!Array.isArray(values) || !values.length) return ''

      return values
        .map((item, index) => `${index + 1}. ${item}`)
        .join('\n\n')
    },

    notes () {
      const notes = [
        // { id: 1, title: 'Notes for Practitioner', data: this.notesForPractitioner?.map((item, idx) => `${idx !== 0 ? '\n' : ''}${idx + 1 + '. ' + item}`).join().replaceAll(/,\n[0-9]/g, ((a) => {
        //   const number = a.replaceAll(',\n', '');
        //   return `.\n${number}`
        // })).replaceAll('..', `.`).replaceAll(/[0-9]+\./g, ((a) => {
        //
        //   return `\n ${a}`
        // })), apiUrl: 'doctor-notes', disabled: true }, // field: 'doctorNotes',
        { id: 1, title: 'Notes for Practitioner', data: this.practitionerNotesText, apiUrl: 'doctor-notes', disabled: true },
        { id: 2, title: 'Notes for Patient', data: this.visit.patientNotes, apiUrl: 'patient-notes', field: 'patientNotes', disabled: ['Completed', 'Closed'].includes(this.visit.status) },
        { id: 3, title: 'Evaluation Notes', data: this.visit.evaluationNotes, apiUrl: 'evaluation-notes', field: 'evaluationNotes', disabled: ['Completed', 'Closed'].includes(this.visit.status) },
        { id: 4, title: 'Five main complaints', data: this.visit.surveyComplaints.$values.join().replaceAll(',', '\n'), apiUrl: 'survey/complaints', field: 'surveyComplaints', disabled: this.visit.finishedOn || ['InProtocol', 'NeedProduct', 'Completed', 'ProtocolEnding'].includes(this.visit.status) }
      ]
      return notes
    },
  },
  methods: {
    ...mapActions('visits', ['updateNotes']),
    ...mapActions('results', ['getResults']),
    updateNote ({ notes, data }) {
      const prepareData = {
        apiUrl: data.apiUrl,
        field: data.field,
        visitId: this.visit.id
      }
      if (data.apiUrl === 'survey/complaints') {
        prepareData.dataForSend = {
          complaints: notes.split('\n')
        }
      } else {
        prepareData.dataForSend = {
          notes: notes
        }
      }
      this.updateNotes(prepareData)
    },
    toggleNotes() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
.notes {
  position: fixed;
  bottom: 0;
  right: -385px;
  height: 100vh;
  width: 385px;
  box-shadow: 0px 30px 40px 0px #14253F14, 0px 0px 1px 0px #0C1A4B1A;
  transition: right 0.3s ease-in-out;

  &.open {
    right: 0;
  }

  @media (min-width: 1498px) {
    height: calc(100vh - 200px);
  }
}

.notes-toggle {
  position: absolute;
  top: -42px;
  left: -94px;
  display: flex;
  align-items: center;
  column-gap: 6px;
  background-color: #718096;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 14px;
  border-radius: 16px 16px 0 0;
  padding: 10px 15px;
  cursor: pointer;
  transform: rotate(-90deg);
  transform-origin: bottom right;

  svg {
    transform: rotate(-90deg);
  }

  &.open {
    svg {
      transform: rotate(90deg);
    }
  }
}

.notes-sidebar {
  position: absolute;
  top: 0;
  right: 0;
  width: 385px;
  height: 100%;
  background-color: #FFFFFF;
  transition: right 0.3s ease-in-out;
  padding: 20px 18px;
  overflow-y: auto;
}
</style>
